import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import ColorPicker from "../components/ColorPicker";
import {
  OneDLayerConfig,
  PipeConfig,
  PipeType,
  setAllSewerPipesVisible,
  setColorPipe,
  setPipesVisibility,
} from "../state/layerOneDMenu";

import LayerSubMenu from "./LayerSubMenu";

interface DefaultProps {
  layerConfig: OneDLayerConfig | PipeConfig;
  setPipesVisibility: typeof setPipesVisibility;
  setColorPipe: typeof setColorPipe;
  setAllSewerPipesVisible: typeof setAllSewerPipesVisible;
}

interface IndentedProps extends DefaultProps {
  indented: true;
  layerType: PipeType;
}

interface NotIndentedProps extends DefaultProps {
  indented: false;
}

type Props = IndentedProps | NotIndentedProps;

function getFormattedMessageLayerName(layerName: string) {
  switch (layerName) {
    case "Sewers":
      return (
        <FormattedMessage id="layerMenuOneDElementLayersublayer.sewers" defaultMessage="Sewers" />
      );
    case "Rain water":
      return (
        <FormattedMessage
          id="layerMenuOneDElementLayersublayer.rainWater"
          defaultMessage="Rain water"
        />
      );
    case "Waste water":
      return (
        <FormattedMessage
          id="layerMenuOneDElementLayersublayer.wasteWater"
          defaultMessage="Waste water"
        />
      );
    case "Mixed":
      return (
        <FormattedMessage
          id="layerMenuOneDElementLayersublayer.mixedWater"
          defaultMessage="Mixed"
        />
      );
    case "Other":
      return (
        <FormattedMessage
          id="layerMenuOneDElementLayersublayer.otherWater"
          defaultMessage="Other"
        />
      );
    default:
      return layerName;
  }
}

const LayerMenuOneDElementLayerLegendItem: React.FC<Props> = (props) => {
  const { indented, layerConfig } = props;
  const { layerName, color, visible } = layerConfig;
  const isDashed = "dashed" in layerConfig && layerConfig.dashed;
  const [showColorPickerModal, setColorPickerModal] = useState(false);

  const formattedMessageLayerName = getFormattedMessageLayerName(layerName);

  // Color picker for sub categories in legend (for example rain water within sewers)
  const formattedMessageColorPicker = (
    <FormattedMessage id="model.color_picker" defaultMessage="Color Picker" />
  );
  const colorPickerHeader = (
    <div>
      {formattedMessageColorPicker}
      {": "}
      {formattedMessageLayerName}
    </div>
  );

  if (indented === false) {
    // Main list item
    return (
      <LayerSubMenu.Item
        active={visible}
        title={layerName}
        onClick={() => props.setAllSewerPipesVisible(!visible)}
      >
        <LayerSubMenu.Item.Name>{formattedMessageLayerName}</LayerSubMenu.Item.Name>
      </LayerSubMenu.Item>
    );
  } else {
    const { layerType } = props;
    // Indented or nested list item
    return (
      <LayerSubMenu.Item
        active={visible}
        title={layerName}
        onClick={() => props.setPipesVisibility(layerType, !visible)}
        indent
      >
        <LayerSubMenu.Item.Name>{formattedMessageLayerName}</LayerSubMenu.Item.Name>
        <LayerSubMenu.Item.Color
          value={color}
          onClick={(e) => {
            e.stopPropagation();
            setColorPickerModal(true);
          }}
          isDashed={isDashed}
        />

        {showColorPickerModal ? (
          <ColorPicker
            initialColor={color}
            onColorSave={(color: string) => props.setColorPipe(layerType, color)}
            closeModal={() => setColorPickerModal(false)}
            header={colorPickerHeader}
          />
        ) : null}
      </LayerSubMenu.Item>
    );
  }
};

export default connect(null, {
  setPipesVisibility,
  setAllSewerPipesVisible,
  setColorPipe,
})(LayerMenuOneDElementLayerLegendItem);
